"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardEventEntityType = exports.DashboardWorkIntervalType = void 0;
var DashboardWorkIntervalType;
(function (DashboardWorkIntervalType) {
    DashboardWorkIntervalType["Unknown"] = "UNKNOWN";
    DashboardWorkIntervalType["Commit"] = "COMMIT";
    DashboardWorkIntervalType["PullRequest"] = "PULL_REQUEST";
    DashboardWorkIntervalType["Task"] = "TASK";
})(DashboardWorkIntervalType = exports.DashboardWorkIntervalType || (exports.DashboardWorkIntervalType = {}));
var DashboardEventEntityType;
(function (DashboardEventEntityType) {
    DashboardEventEntityType["JiraIssue"] = "JIRA_ISSUE";
    DashboardEventEntityType["GitHubCommit"] = "GITHUB_COMMIT";
    DashboardEventEntityType["GitHubPullRequest"] = "GITHUB_PULL_REQUEST";
})(DashboardEventEntityType = exports.DashboardEventEntityType || (exports.DashboardEventEntityType = {}));
//# sourceMappingURL=dashboard-work.js.map